import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  invalidateMemberQueries as invalidateMemberQueriesFn,
  invalidateMemberQueriesAfterDelay as invalidateMemberQueriesAfterDelayFn,
  type MemberInvalidateQueryKey,
} from "@/src/utils/memberInvalidateQueries";

/**
 * 失效会员相关 React Query 缓存（可选额外 key，如 Retain 场景的 retention stats）
 */
export const useInvalidateMemberQueries = (
  extraKeys: readonly MemberInvalidateQueryKey[] = [],
) => {
  const queryClient = useQueryClient();

  const invalidateMemberQueries = useCallback(() => {
    invalidateMemberQueriesFn(queryClient, extraKeys);
  }, [queryClient, extraKeys]);

  const invalidateMemberQueriesAfterDelay = useCallback(
    (delayMs?: number) =>
      invalidateMemberQueriesAfterDelayFn(queryClient, delayMs, extraKeys),
    [queryClient, extraKeys],
  );

  return { invalidateMemberQueries, invalidateMemberQueriesAfterDelay };
};
